import Popup from 'vintage-popup';

Popup.expose($);
const $popup = $('[data-popup-target]');

$popup.popup();


// WEBPACK FOOTER //
// ./src/js/components/popupInit.js